export const menuItems = [
    {
        id: 1,
        label: 'menuitems.reports.list.self',
        icon: 'bx-user-circle',
        link: '/',
    },
    {
        id: 2,
        label: 'menuitems.reports.list.team',
        icon: 'bx-home-circle',
        link: '/reports/team',
    },
    {
        id: 3,
        label: 'menuitems.reports.list.company',
        icon: 'bx-pyramid',
        link: '/reports/company',
    },
];

